//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import FontFaceObserver from 'fontfaceobserver';

export default {
    data() {
        return {
            containerWidth: 0,
            isScrollTriggerActive: false,
            isLoading: true,
            gridItems: [
                {
                    id: 1,
                    padding: 'lg:pt-80 pt-40',
                    images: ['/images/trophy/grid-1.jpg', '/images/trophy/grid-2.jpg'],
                },
                {
                    id: 2,
                    padding: 'lg:pt-40 pt-20',
                    images: ['/images/trophy/grid-3.jpg', '/images/trophy/grid-4.jpg'],
                },
                {
                    id: 3,
                    padding: null,
                    images: ['/images/trophy/grid-5.jpg', '/images/trophy/grid-6.jpg'],
                },
            ],
            timelines: [],
            slideDurationFactor: 2,
            sequence: {
                debounce: null,
                canvas: null,
                context: null,
                currentFrame: 0,
                frameCount: 134,
                frameRate: 30,
                height: null,
                images: [],
                isLoading: true,
                width: null,
            },
            slides: Object.values(this.$t('slides')),
        };
    },
    head() {
        return {
            bodyAttrs: {
                class: `page-trophy ${!this.isLoading ? 'is-loaded' : ''}`,
            },
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: 'Beker',
                },
                {
                    name: 'robots',
                    content: 'noindex,follow',
                },
            ],
            title: 'Beker',
        };
    },
    mounted() {
        window.scrollTo(0, 0);
        this.containerWidth = window.innerWidth;

        const fontHeading = new FontFaceObserver('Barlow Condensed', {
            weight: 800,
        });

        const fontBody = new FontFaceObserver('Petrona', {
            weight: 500,
        });

        Promise.all([fontHeading.load(), fontBody.load()]).then(() => {
            this.isLoading = false;
            this.refreshScrollTrigger();
        });

        this.setupPinSlides();
        this.setupSequence();

        document.addEventListener('lazyloaded', this.handleLazyLoaded);
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        document.removeEventListener('lazyloaded', this.handleLazyLoaded);
        window.removeEventListener('resize', this.handleResize);

        this.timelines.forEach((timeline) => {
            timeline.kill(true);
        });

        gsap.set('.js-slide', { clearProps: true });
        gsap.set('.js-slide-content', { clearProps: true });
        gsap.set('.js-slide-image', { clearProps: true });

        this.timelines = [];
    },
    methods: {
        handleLazyLoaded() {
            this.refreshScrollTrigger(true);
        },

        refreshScrollTrigger(safe = false) {
            if (this.isScrollTriggerActive) return;

            ScrollTrigger.refresh(safe);
        },

        setupPinSlides() {
            const progressBarLength =
                this.slides.length * window.innerHeight * this.slideDurationFactor;
            const sequenceLength = this.sequence.frameCount * this.sequence.frameRate;
            const scrollHeight = sequenceLength + progressBarLength;

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.slidesContainer,
                    pinType: 'fixed',
                    pin: true,
                    start: 'top top',
                    scrub: true,
                    end: `+=${scrollHeight}px`,
                    onEnter: () => {
                        this.isScrollTriggerActive = true;
                    },
                    onLeave: () => {
                        this.isScrollTriggerActive = false;
                    },
                    onEnterBack: () => {
                        this.isScrollTriggerActive = true;
                    },
                    onLeaveBack: () => {
                        this.isScrollTriggerActive = false;
                    },
                    onUpdate: ({ start, end, progress }) => {
                        const total = end - start;
                        const current = progress * total;
                        const barProgress = Math.min(Math.max(0, current / progressBarLength), 1);

                        gsap.set('.js-slides-progress', {
                            width: `${barProgress * 100}%`,
                        });

                        const sequenceCurrent = current - progressBarLength;
                        const sequenceEnd = total - progressBarLength;
                        const sequenceProgress = Math.min(
                            Math.max(0, sequenceCurrent / sequenceEnd),
                            1,
                        );

                        this.handleScroll({ progress: sequenceProgress });
                    },
                },
            });

            const slides = gsap.utils.toArray('.js-slide');
            const slidesContent = gsap.utils.toArray('.js-slide-content');
            const slidesImages = gsap.utils.toArray('.js-slide-image');

            const slideCalc = (value) => {
                return (progressBarLength / this.slides.length) * value;
            };

            slides.forEach((slide, index) => {
                timeline.to(
                    slide,
                    {
                        autoAlpha: index === slides.length - 1 ? 1 : 0,
                        duration: slideCalc(0.3),
                        delay: slideCalc(0.7),
                    },
                    slideCalc(index),
                );
            });

            slidesContent.forEach((content, index) => {
                timeline.to(
                    content,
                    {
                        autoAlpha: 1,
                        duration: slideCalc(0.3),
                    },
                    slideCalc(index),
                );
            });

            slidesImages.forEach((image, index) => {
                timeline.to(
                    image,
                    {
                        duration: slideCalc(1),
                        y: -10,
                    },
                    slideCalc(index),
                );
            });

            timeline.to(
                '.js-slide-progressbar',
                {
                    autoAlpha: 0,
                    duration: slideCalc(0.3),
                },
                progressBarLength,
            );

            timeline.to(
                `.js-slide-gradient-${this.slides.length - 1}`,
                {
                    autoAlpha: 0,
                    duration: slideCalc(0.3),
                },
                progressBarLength,
            );

            timeline.to(
                slidesContent[this.slides.length - 1],
                {
                    autoAlpha: 0,
                    duration: slideCalc(0.3),
                },
                progressBarLength,
            );

            timeline.to(
                '.js-slide',
                {
                    duration: sequenceLength,
                },
                progressBarLength,
            );

            this.timelines.push(timeline);
        },

        loadImage(src, index) {
            return new Promise((resolve) => {
                const img = new Image();
                const handleResolve = () => {
                    this.sequence.images[index] = img;

                    resolve();
                };
                img.onload = handleResolve;
                img.onerror = handleResolve;
                img.src = src;
            });
        },

        setImages() {
            const orientation = window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
            const filePath = `/images/trophy/sequence/${orientation}/Transition-sequence_`;

            const images = Array.from(Array(this.sequence.frameCount).keys()).map(
                (index) => `${filePath}${index.toString().padStart(5, '0')}.jpg`,
            );

            return Promise.all([...images.map(this.loadImage)]).then(() => {
                this.sequence.isLoading = false;
            });
        },

        async setupSequence() {
            await this.setImages();

            this.sequence.isLoading = false;

            await this.$nextTick();

            this.sequence.canvas = document.querySelector('.canvas-sequence');
            this.sequence.context = this.sequence.canvas.getContext('2d');

            this.handleScroll({ progress: 0 });
            this.handleResize();
        },

        handleResize() {
            this.containerWidth = window.innerWidth;
            const containerHeight = window.innerHeight + 20;
            const ratio = containerHeight > this.containerWidth ? [828, 1334] : [2240, 1260];

            if (this.containerWidth / containerHeight > ratio[0] / ratio[1]) {
                this.sequence.width = this.containerWidth;
                this.sequence.height = (ratio[1] / ratio[0]) * this.sequence.width;
            } else {
                this.sequence.height = containerHeight;
                this.sequence.width = (ratio[0] / ratio[1]) * this.sequence.height;
            }

            this.sequence.canvas.width = this.sequence.width;
            this.sequence.canvas.height = this.sequence.height;
            this.sequence.context.width = this.sequence.width;
            this.sequence.context.height = this.sequence.height;

            this.refreshScrollTrigger();

            clearTimeout(this.sequence.debounce);

            this.sequence.debounce = setTimeout(async () => {
                await this.setImages();
                requestAnimationFrame(() => this.updateImage());
            }, 500);
        },

        handleScroll({ progress }) {
            this.sequence.currentFrame = Math.max(
                0,
                Math.floor(progress.toFixed(3) * this.sequence.frameCount),
            );

            requestAnimationFrame(() => this.updateImage());
        },

        updateImage() {
            if (!this.sequence.context) return;

            const frame = Math.min(
                Math.max(this.sequence.currentFrame, 0),
                this.sequence.frameCount - 1,
            );
            this.sequence.context.drawImage(
                this.sequence.images[frame],
                0,
                0,
                this.sequence.width,
                this.sequence.height,
            );
        },

        handleVideoVisibility(isVisible, entry) {
            if (!isVisible) return;

            gsap.to(entry.target, 0.8, {
                scaleX: 1,
                scaleY: 1,
            });

            this.$refs['trophy-video'].play();
        },
    },
};
